import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'; 

@Component({
  selector: 'app-review-cashout-request-modal',
  templateUrl: './review-cashout-request-modal.component.html',
  styleUrls: ['./review-cashout-request-modal.component.css']
})
export class ReviewCashoutRequestModalComponent implements OnInit {
  @Input() cashHours: any;
  @Input() payPeriod: any;
  @Input() stdWorkdayHours: any;
  @Input() defaultFridayHours: any;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  cancelClicked() {
    this.activeModal.close('cancel');
  };

  submitClicked() {
    this.activeModal.close('submit');
  }
}
